import { defineComponent, h } from 'vue';
import { Modal, modalProps, ModalProps } from '@/ui/components/Modal';
import { button } from '@/ui/components';
import { ButtonProps } from '@/ui/components/Button';

interface InformationModalProps extends ModalProps {
  confirmText: string;
  width?: string;
  confirmationButtonProps: ButtonProps;
}

export const InformationModal = defineComponent<InformationModalProps>({
  name: 'InformationModal',
  props: [...modalProps, 'confirmText', 'confirmationButtonProps'],
  setup(props, ctx) {
    return function render() {
      return h(Modal, { props: { ...props, hideClose: true, width: props.width ?? '500px' } }, [
        ctx.slots.default?.(),
        h('template', { slot: 'actions' }, [
          button(props.confirmText, () => ctx.emit('accepted'), undefined, props.confirmationButtonProps),
        ]),
      ]);
    };
  },
});
